import { assert } from 'common';
import {
  DocumentAnnotation,
  EllipseAnnotation,
  ImageAnnotation,
  LineAnnotation,
  PathAnnotation,
  RectangleAnnotation,
  StampAnnotation,
  TextAnnotation,
} from 'models';

// Currently not all types are supported.
export declare type SupportedDocumentAnnotation =
  | TextAnnotation
  | StampAnnotation
  | RectangleAnnotation
  | LineAnnotation
  | ImageAnnotation
  | EllipseAnnotation
  | PathAnnotation;

/**
 * Asserts that the DocumentAnnotation is one of the supported types.
 * @todo This should be largely removable/refactored when all annotations are supported.
 * @param annotation - Annotation.
 * @throws - Throws if the annotation is not supported.
 */
export function assertSupportedAnnotation(
  annotation: DocumentAnnotation | undefined
): asserts annotation is SupportedDocumentAnnotation {
  assert(
    annotation instanceof RectangleAnnotation ||
      annotation instanceof TextAnnotation ||
      annotation instanceof StampAnnotation ||
      annotation instanceof RectangleAnnotation ||
      annotation instanceof LineAnnotation ||
      annotation instanceof ImageAnnotation ||
      annotation instanceof EllipseAnnotation ||
      annotation instanceof PathAnnotation,
    'Unsupported annotation type.'
  );
}
